import React from 'react';
import { ChevronDown } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ObjectionsSection() {
  const faqs = [{
    q: 'No tengo tiempo',
    a: 'Precisamente por eso es una guía rápida. No son 300 páginas. Son 7 rutas al grano para que elijas una y empieces en menos de 7 días.'
  }, {
    q: '¿Y si no me funciona?',
    a: 'Ahora estás en cero claridad. Con la guía tendrás 7 caminos concretos. No necesitas que te funcionen las 7, solo necesitas UNA para empezar.'
  }, {
    q: 'No sé nada de negocios ni ventas',
    a: 'La guía está escrita para principiantes. Si sabes mandar un WhatsApp, sabes usar esta guía. Incluye guiones listos para copiar.'
  }, {
    q: 'Me da miedo que sea estafa',
    a: 'Tu miedo es válido. Esta guía NO promete millones ni pide inversiones raras. Incluye un checklist de seguridad para que aprendas a cuidarte.'
  }];
  return <section className="py-12 bg-white" data-id="element-47">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-48">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-warm-900 mb-12" data-id="element-49">
          ¿Te suena esto?
        </h2>

        <div className="space-y-6 mb-12" data-id="element-50">
          {faqs.map((faq, idx) => <div key={idx} className="border border-warm-200 rounded-xl p-6 hover:border-rose-200 transition-colors bg-warm-50" data-id="element-51">
              <h3 className="text-lg font-bold text-warm-900 mb-2 flex items-center justify-between" data-id="element-52">
                "{faq.q}"
              </h3>
              <p className="text-warm-600 leading-relaxed" data-id="element-53">{faq.a}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-54">
          <CTAButton onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-55">
            Obtener la Guía
          </CTAButton>
        </div>
      </div>
    </section>;
}